import { ISwimlanesLocalStorage, SWIMLANES_LOCALSTORAGE } from '../types';

export const getSwimlanesLocalStorage = (
): ISwimlanesLocalStorage => {
    const data = localStorage.getItem(SWIMLANES_LOCALSTORAGE);
    const swimlanesLocalStorage: ISwimlanesLocalStorage = data ? JSON.parse(data) : {};
    return swimlanesLocalStorage;
}
